<template>
  <div id="app" class="container-fluid px-0">
    <div
      class="col-12 nav flex-x-between"
      :class="{ onScroll: !view.topOfPage }"
    >
      <img
        :src="isDark ? '/dark_logo.png' : '/light_logo.png'"
        class="logo"
        alt=""
      />
    </div>
    <router-view
      :key="$route.fullPath"
      :isDark="isDark"
      class="router_view mx-0 w-100"
    >
    </router-view>
    <themeToggler @toggle="changeTheme" />
    <slide-y-down-transition>
      <button
        class="no-width scroll-to-top"
        v-if="showScrollToTop"
        @click="scrollToTop"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-chevron-up"
        >
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </slide-y-down-transition>
  </div>
</template>

<script>
import themeToggler from "./components/toggleTheme.vue";

export default {
  data() {
    return {
      showScrollToTop: false,
      isDark: false,
      view: {
        topOfPage: true,
      },
    };
  },
  computed: {},
  mounted() {},
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {},
  components: {
    themeToggler,
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeTheme(mode) {
      this.isDark = mode;
    },
    handleScroll(e) {
      if (window.pageYOffset > 0) {
        if (this.view.topOfPage) this.view.topOfPage = false;
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
      }

      this.showScrollToTop = e.target.scrollingElement.scrollTop > 500;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style>
html {
  scroll-behavior: smooth;
}
.nav {
  background: rgba(0, 0, 0, 0);
  padding: 5px 15px !important;
  position: fixed !important;
  top: 0px;
  left: 0px;
  width: calc(100vw) !important;
  right: 10px;
  z-index: 100;
  transition: all 0.3s ease-in-out;
}
.logo {
  width: 150px;
  transition: all 0.3s ease-in-out;
}
.nav.onScroll {
  background: rgb(var(--background-1));
  box-shadow: 0px 4px 25px -4px rgb(0, 0, 0, 0.15);
}
.nav.onScroll img {
  width: 130px;
}
.scroll-to-top {
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 1000000;
}
button.no-width.scroll-to-top {
  border: 0px;
  background: rgb(105, 81, 164);
  border-radius: 100%;
  height: 35px;
  width: 35px;
  box-shadow: 0px 4px 25px -4px #6951a4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
body {
  margin: 0px !important;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.primary {
  color: #6951a4;
}
.product-card {
  background: rgb(var(--background-1));
  border-radius: 8px;
  box-shadow: 0px 4px 25px -8px rgb(0 0 0 / 20%);
  padding: 5px;
  margin-bottom: 10px;
}
.code {
  color: #6951a4;
  display: inline-block !important;
  text-decoration: unset;
}
.main {
  position: relative;
  max-width: 100vw;
  overflow-x: hidden;
}
#products {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
p,
h4 {
  margin-top: 0px !important;
  margin-bottom: 10px !important;
}
.flex-start {
  align-items: flex-start !important;
}
#products td,
#products th {
  border: 1px solid rgb(235, 235, 235);
  padding: 8px;
}
th {
  font-size: 12px;
}
.sm-text {
  font-size: 14px !important;
}
.xs-text {
  font-size: 12px !important;
  color: rgb(var(--text), 0.7) !important;
}
#products tr:hover {
  background-color: #f2f2f2;
}
.gray-bg.item-row {
  padding: 1px !important;
}
.received_date {
  background: rgb(0, 255, 42, 0.15);
  color: rgb(0, 189, 31);
  font-size: 12px;
  padding: 5px;
  border-radius: 8px;
}
.refund {
  background: rgb(255, 0, 0, 0.15);
  color: rgb(207, 0, 0);
  font-size: 12px;
  padding: 5px;
  border-radius: 8px;
}
#products th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #6951a4;
  color: white;
}

.item-row {
  display: flex;
  align-items: center;
  position: relative;
}
img.done-img {
  width: 70px !important;
  height: 100% !important;
  position: absolute !important;
  object-fit: contain !important;
  left: 250px;
}
.number {
  background: #6951a4;
  color: #fff;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 10px !important;
  margin-right: 5px;
}
.item-row img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.px-2 {
  margin-right: 10px;
  margin-left: 10px;
}
.pt-3 {
  padding-top: 15px;
}
.mb-3 {
  margin-bottom: 15px;
}
.route-view {
  /* height: 100vh; */
}
.cool-lightbox .cool-lightbox__inner {
  padding: 0px !important;
}
/* .row {
  padding: 0px 10px;
} */
.cool-lightbox {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100vw !important;
  height: 100vh !important;
  padding: 0px !important;
  -webkit-backdrop-filter: blur(8px) !important;
}
button.cool-lightbox-toolbar__btn {
  background: rgb(0, 0, 0, 0.3) !important;
  color: #fff !important;
  border-radius: 5px !important;
}
.cool-lightbox .cool-lightbox__slide img {
  width: 100%;
  height: 100%;
  border-radius: 0px !important;
  object-fit: contain;
}
.cool-lightbox-toolbar {
  top: 5px !important;
  right: 5px !important;
}
.flex-x-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
p,
a {
  font-size: 16px !important;
}
.item-img {
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
  /* filter: brightness(0.9); */
  cursor: pointer;
}
.go-to-app {
  padding: 8px 15px;
  display: block;
  background: #6951a4;
  color: #fff;
  text-decoration: none;
  margin-top: 10px;
  border-radius: 5px;
}

.card-product {
  background: rgb(var(--background-1));
  box-shadow: 0px 4px 25px -8px rgb(0 0 0 / 20%);
  border-radius: 10px;
  padding: 8px !important;
  margin: 15px 0px !important;
}
.gray-bg {
  background: rgb(var(--background-2));
  padding: 8px;
  border-radius: 5px;
  text-align: start !important;
  margin: 8px 0px !important;
}
</style>